import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

import { loadCSS, loadJS } from "../../utils/loadAssets";
import Loader from "../users/components/PageLoader"
// USER PAGES
import Home from "./Home";
import Product from "../users/components/Product";
import Login from "../users/Login";
import Checkout from "../users/components/Checkout";
import Favourites from "../users/components/Favourites";
import MyOrders from "../users/components/MyOrders";
import Allcategory from "../users/components/Allcategory";
import Contactus from "../users/components/Contactus";
import ProductCustomizer from '../users/components/Productcustomizer';
import Savedaddresses from "../users/components/profile/Savedaddresses";
import Profileoverview  from "../users/components/profile/Profileoverview";
export default function UserApp() {
  // ✅ Hook MUST be inside component
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAssets = async () => {
      await Promise.all([
        // CSS
        loadCSS("/websiteAssets/vendor/bootstrap-select/dist/css/bootstrap-select.min.css"),
        loadCSS("/websiteAssets/vendor/swiper/swiper-bundle.min.css"),
        loadCSS("/websiteAssets/vendor/animate/animate.css"),
        loadCSS("/websiteAssets/vendor/lightgallery/dist/css/lightgallery.css"),
        loadCSS("/websiteAssets/vendor/lightgallery/dist/css/lg-thumbnail.css"),
        loadCSS("/websiteAssets/vendor/lightgallery/dist/css/lg-zoom.css"),
        loadCSS("/websiteAssets/css/style.css"),
        loadCSS("/websiteAssets/css/skin/skin-1.css"),

        // JS
        loadJS("/websiteAssets/js/jquery.min.js"),
        loadJS("/websiteAssets/vendor/wow/wow.min.js"),
        loadJS("/websiteAssets/vendor/bootstrap/dist/js/bootstrap.bundle.min.js"),
        loadJS("/websiteAssets/vendor/bootstrap-select/dist/js/bootstrap-select.min.js"),
        loadJS("/websiteAssets/vendor/bootstrap-touchspin/bootstrap-touchspin.js"),
        loadJS("/websiteAssets/vendor/swiper/swiper-bundle.min.js"),
        loadJS("/websiteAssets/vendor/magnific-popup/magnific-popup.js"),
        loadJS("/websiteAssets/vendor/imagesloaded/imagesloaded.js"),
        loadJS("/websiteAssets/vendor/masonry/masonry-4.2.2.js"),
        loadJS("/websiteAssets/vendor/masonry/isotope.pkgd.min.js"),
        loadJS("/websiteAssets/vendor/countdown/jquery.countdown.js"),
        loadJS("/websiteAssets/vendor/wnumb/wNumb.js"),
        loadJS("/websiteAssets/vendor/lightgallery/dist/lightgallery.min.js"),
        loadJS("/websiteAssets/vendor/group-slide/group-loop.js"),
        loadJS("/websiteAssets/vendor/lightgallery/dist/plugins/thumbnail/lg-thumbnail.min.js"),
        loadJS("/websiteAssets/js/custom.min.js"),
        loadJS("/websiteAssets/js/dz.carousel.js"),
        loadJS("/websiteAssets/js/custom.js"),
     
      ]);

      // ✅ Assets fully loaded
      setLoading(false);
    };

    loadAssets();
  }, []);

  // ✅ Loader BEFORE rendering routes
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fff",
        }}
      >
        <Loader/>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/product/:categoryId" element={<Product />} />
      <Route path="/login" element={<Login />} />
      <Route path="/checkout" element={<Checkout />} />
<Route path="/my-orders" element={<MyOrders />} />
<Route path="/Allcategory" element={<Allcategory />} />
<Route path="/Favourites" element={<Favourites />} />
<Route path="/Contactus" element={<Contactus />} />
<Route path="/customize/:productId" element={<ProductCustomizer />} />
<Route path="/profile/address" element={<Savedaddresses  />} />
<Route path="/profile/overview" element={<Profileoverview  />} />
    </Routes>
  );
}
